export const salesConfig = {
  enforcePaidAccess: false,
  checkoutEnabled: false,
  allowTestLicenses: false,
  freeRowLimit: 100,
  monthlyCheckoutUrl: 'https://catalogfix.lemonsqueezy.com/checkout/buy/d080540a-8731-4cae-9ace-945987571dac',
  annualCheckoutUrl: 'https://catalogfix.lemonsqueezy.com/checkout/buy/a91d3faa-3700-437f-b701-a4f5a5ed3742',
  productName: 'CatalogFix Pro – WooCommerce Catalog Validator & Exporter',
  allowedVariants: ['Monthly', 'Annual'],
} as const
